(() => {
  try {
    console.log("[XB i18n] cargado ✅");

    const normalize = (s) => (s || "").replace(/\s+/g, " ").trim();

    const DICT = {
      es: {
        "Wishlist Page": "Lista de deseos",
        "Wishlist": "Lista de deseos",
        "Share on:": "Compartir:",
        "Share on": "Compartir",
        "Product name": "Producto",
        "Unit price": "Precio unitario",
        "Stock status": "Estado de stock",
        "In stock": "En stock",
        "Add to cart": "Añadir al carrito",
        "Add to Cart": "Añadir al carrito",
        "Remove": "Eliminar",
        "Add to wishlist": "Añadir a la lista de deseos",
        "Add To Wishlist": "Añadir a la lista de deseos",
        "Remove from wishlist": "Quitar de la lista de deseos",
        "Remove From Wishlist": "Quitar de la lista de deseos",
        "Save for Later": "Guardar para más tarde",
        "Save for later": "Guardar para más tarde",
        "To save your wishlist please login or register.": "Para guardar tu lista de deseos, inicia sesión o regístrate.",
        "Do you want to save this item for later?": "¿Quieres guardar este artículo para más tarde?",
      },

      fr: {
        "Wishlist Page": "Liste de souhaits",
        "Wishlist": "Liste de souhaits",
        "Share on:": "Partager :",
        "Share on": "Partager",
        "Product name": "Produit",
        "Unit price": "Prix unitaire",
        "Stock status": "État du stock",
        "In stock": "En stock",
        "Add to cart": "Ajouter au panier",
        "Add to Cart": "Ajouter au panier",
        "Remove": "Retirer",
        "Add to wishlist": "Ajouter à la liste de souhaits",
        "Add To Wishlist": "Ajouter à la liste de souhaits",
        "Remove from wishlist": "Retirer de la liste de souhaits",
        "Remove From Wishlist": "Retirer de la liste de souhaits",
        "Save for Later": "Enregistrer pour plus tard",
        "To save your wishlist please login or register.": "Pour enregistrer votre liste de souhaits, veuillez vous connecter ou vous inscrire.",
      },

      pt: {
        "Wishlist Page": "Lista de desejos",
        "Wishlist": "Lista de desejos",
        "Share on:": "Partilhar:",
        "Share on": "Partilhar",
        "Product name": "Produto",
        "Unit price": "Preço unitário",
        "Stock status": "Estado do stock",
        "In stock": "Em stock",
        "Add to cart": "Adicionar ao carrinho",
        "Add to Cart": "Adicionar ao carrinho",
        "Remove": "Remover",
        "Add to wishlist": "Adicionar à lista de desejos",
        "Add To Wishlist": "Adicionar à lista de desejos",
        "Remove from wishlist": "Remover da lista de desejos",
        "Remove From Wishlist": "Remover da lista de desejos",
        "Save for Later": "Guardar para mais tarde",
        "Save for later": "Guardar para mais tarde",
        "To save your wishlist please login or register.": "Para guardar a sua lista de desejos, inicie sessão ou registe-se.",
        "Do you want to save this item for later?": "Pretende guardar este artigo para mais tarde?",
      },
    };

    const getLang = () => {
      if (window.Shopify && window.Shopify.locale) return window.Shopify.locale.toLowerCase().split("-")[0];
      const htmlLang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
      if (htmlLang) return htmlLang.split("-")[0];
      const first = window.location.pathname.split("/").filter(Boolean)[0];
      if (first && first.length <= 5) return first.toLowerCase().split("-")[0];
      return "en";
    };

    const lang = getLang();
    const baseMap = DICT[lang] || DICT.es;

    const map = {};
    Object.keys(baseMap).forEach((k) => (map[normalize(k)] = baseMap[k]));

    console.log("[XB i18n] lang:", lang);

    const translateDoc = (docOrRoot) => {
      if (!docOrRoot) return;

      const root = docOrRoot.body || docOrRoot.documentElement || docOrRoot;
      if (!root) return;

      try {
        const nodes = root.querySelectorAll ? root.querySelectorAll("*") : [];
        for (const el of nodes) {
          if (!el.getAttribute) continue;

          const attrs = [
            "value",
            "placeholder",
            "aria-label",
            "title",
            "data-tooltip",
            "data-title",
            "data-original-title",
            "data-tippy-content",
          ];

          for (const a of attrs) {
            const v = el.getAttribute(a);
            const k = normalize(v);
            if (v && map[k]) el.setAttribute(a, map[k]);
          }
        }
      } catch (e) {}

      try {
        const NF = (root.ownerDocument?.defaultView?.NodeFilter) || window.NodeFilter;
        if (!NF) return;

        const walker = (root.ownerDocument || document).createTreeWalker(
          root,
          NF.SHOW_TEXT,
          {
            acceptNode: (n) => {
              const t = normalize(n.nodeValue);
              if (!t) return NF.FILTER_REJECT;
              const p = n.parentElement;
              if (p && (p.tagName === "SCRIPT" || p.tagName === "STYLE")) return NF.FILTER_REJECT;
              return NF.FILTER_ACCEPT;
            },
          }
        );

        let node;
        while ((node = walker.nextNode())) {
          const raw = node.nodeValue || "";
          const key = normalize(raw);

          if (map[key]) {
            node.nodeValue = map[key];
            continue;
          }

          if (key.includes("Apologies, no results were found")) {
            node.nodeValue =
              lang === "fr"
                ? "Désolé, aucun résultat n’a été trouvé. Essayez d’ajouter des articles depuis les "
                : lang === "pt"
                ? "Lamentamos, não foram encontrados resultados. Experimente adicionar artigos desde "
                : "Lo sentimos, no se encontraron resultados. Prueba a añadir productos desde las ";
            continue;
          }

          if (key.includes("To save your wishlist please")) {
            node.nodeValue =
              lang === "fr"
                ? "Pour enregistrer votre liste de souhaits, "
                : lang === "pt"
                ? "Para guardar a sua lista de desejos, "
                : "Para guardar tu lista de deseos, ";
            continue;
          }
        }
      } catch (e) {}

      try {
        if (!root.querySelectorAll) return;
        const all = root.querySelectorAll("*");
        for (const el of all) {
          if (el.shadowRoot) translateDoc(el.shadowRoot);
        }
      } catch (e) {}

      try {
        const rootEl = root;
        const linkTargets = rootEl.querySelectorAll?.("a, button") || [];

        for (const el of linkTargets) {
          const t = normalize(el.textContent);

          if (t === "login" || t === "Login") {
            el.textContent =
              lang === "fr" ? "Se connecter" : lang === "pt" ? "Iniciar sessão" : "inicia sesión";
          }

          if (t === "register" || t === "Register") {
            el.textContent =
              lang === "fr" ? "S’inscrire" : lang === "pt" ? "Registar-se" : "regístrate";
          }

          if (t === "no, thanks" || t === "No, Thanks") {
            el.textContent =
              lang === "fr" ? "Non, Merci" : lang === "pt" ? "Não, obrigado" : "No, Gracias";
          }

          if (t === "save" || t === "Save") {
            el.textContent =
              lang === "fr" ? "Enregistrer" : lang === "pt" ? "Guardar" : "Guardar";
          }
        }

        const NF = (rootEl.ownerDocument?.defaultView?.NodeFilter) || window.NodeFilter;
        if (NF && rootEl.ownerDocument?.createTreeWalker) {
          const w2 = rootEl.ownerDocument.createTreeWalker(rootEl, NF.SHOW_TEXT);
          let n;
          while ((n = w2.nextNode())) {
            const txt = n.nodeValue || "";
            if (/\bor\b/i.test(txt)) {
              n.nodeValue = txt.replace(
                /\bor\b/gi,
                lang === "fr" ? "ou" : lang === "pt" ? "ou" : "o"
              );
            }
          }
        }
      } catch (e) {}
    };

    const hook = (doc) => {
      translateDoc(doc);

      const target = doc.body || doc.documentElement;
      const obs = new MutationObserver(() => translateDoc(doc));

      obs.observe(target, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
      });
    };

    const tryIframes = () => {
      document.querySelectorAll("iframe").forEach((ifr) => {
        const run = () => {
          try {
            const idoc = ifr.contentDocument;
            if (idoc) hook(idoc);
          } catch (e) {}
        };
        ifr.addEventListener("load", run);
        setTimeout(run, 300);
        setTimeout(run, 1200);
      });
    };

    hook(document);
    tryIframes();
    setTimeout(() => translateDoc(document), 300);
    setTimeout(() => translateDoc(document), 1200);
    setTimeout(() => translateDoc(document), 2500);

    new MutationObserver(() => tryIframes()).observe(document.body, { childList: true, subtree: true });

  } catch (err) {
    console.error("[XB i18n] ERROR:", err);
  }
})();
